/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Next_PageInputs */

const vi_common_next_page = /** @type {(inputs: Common_Next_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang sau`)
};

/**

* @param {Common_Next_PageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_next_page = /** @type {((inputs?: Common_Next_PageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Next_PageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_next_page(inputs)
});